import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'pluralStatistics',
})
export class PluralStatisticsPipe implements PipeTransform {
  /**
   * @description Identifies whether plural or singular texting is to be
   *              applied based on count param. 0 count is treated as plural.
   * @param { string[]} titles
   * @param { number } count
   * @returns { string }
   */
  public transform(titles: string[], count: number): string {
    return count === 1 ? titles[1] : titles[0];
  }
}
